import { cn } from "@workspace/frontend-ui";

type Props = ImgProps & { width: number; height: number };

const EagerImg: FC<Props> = ({
  id,
  src,
  className,
  width,
  height,
  onLoad,
  onClick,
  dataAction,
  style,
  alt = "",
}) => {
  if (!src) {
    return <img src={src} alt={alt} className={className} />;
  }
  return (
    <img
      id={id}
      alt={alt}
      src={resolveSrc(src)}
      width={width}
      height={height}
      onClick={onClick}
      onLoad={onLoad}
      className={cn(className)}
      data-action={dataAction}
      fetchPriority="high"
      style={style}
    />
  );
};

const resolveSrc = (src: string) =>
  src.startsWith("http") ? src : `https:${src}`;

export default EagerImg;
